export enum StorageKeys {
    AppState = "app-state",
    PropertyGroupId = "property-group-id",
    ActivePropertyId = "active-property-id",
}
